import type { ProgressSummaryResponseModel } from "@/features/collections/api/models/ProgressSummaryResponseModel";
import type { ProgressSummarySortOrder } from "@/features/collections/ProgressSummarySortOrder";
import { useHTTP, type PaginatedResponseModel } from "@/lib/http";
import { useHTTPQueryWithCursor } from "@/lib/http/useHTTPQueryWithCursor";

export const useProgressSummaries = (collectionId: string, searchQuery: string, includeCompleted: boolean, sortOrder: ProgressSummarySortOrder) => {
	const http = useHTTP("Required");
	return useHTTPQueryWithCursor({
		queryKey: ["progressSummaries", collectionId, includeCompleted, sortOrder, searchQuery],
		queryFn: ({ pageParam = 0 }) => {
			return http<PaginatedResponseModel<ProgressSummaryResponseModel>>({
				method: "GET",
				url: `/collection/${collectionId}/progress-summaries?cursor=${pageParam}&includeCompleted=${includeCompleted}&sortOrder=${sortOrder}` + (searchQuery.trim() ? `&q=${encodeURIComponent(searchQuery)}` : "")
			});
		}
	});
};
